const relatedLink = {
    resolutionMode: "relatedLinkTitle"
};

relatedLink.relatedLinksStates = []

relatedLink.load = function ($newContent) {
    const listPromises = [];
    const $relatedLinksItems = $newContent.find("[data-role='related-link-item']");

    for (const relatedLinkItem of $relatedLinksItems) {
        const topicHrefNotReduce = relatedLinkItem.getAttribute("data-target");
        const topicHref = topicHrefNotReduce.substring(1, topicHrefNotReduce.length - 7);

        if (!loadDDB.topicExists(topicHref)) {
            relatedLinkItem.remove();

        } else {
            const topic = loadDDB.searchTopicByHref(topicHref);
            if (topic !== undefined) {
                let id = relatedLink.searchHrefId(topic);

                relatedLinkItem.setAttribute("data-target", "#".concat(id))
                relatedLinkItem.setAttribute("href", "#".concat(id))
                relatedLinkItem.setAttribute("data-targettopichref", topic.file)

                $(relatedLinkItem).on("click", function (event) {
                    event.preventDefault()
                    localStorage.setItem("relatedLinkHref", topic.file)
                });        

                listPromises.push(relatedLink.extractTitle(topic, $(relatedLinkItem)))
            } else {
                console.warn("The topic href attribute [".concat(topicHref).concat("] not found."))
            }
        }
    }

    if (listPromises.length === 0) {
        $newContent.find("[data-role='related-links-wrapper']").remove()

    } else {
        Promise.all(listPromises).then(function () {
            relatedLink.initShowRelatedLink($newContent)
        }).catch(function (error) {
            console.error("[RelatedLink.load] Promises error: ", error)
        })
    }
}

relatedLink.extractTitle = function (topic, $element) {
    return new Promise(function (resolve, reject) {
        loadContent.loadContentDoc(topic.file, function success(data) {
            const fragment = loadContent.transformContentToTitleWithXSL(data, loadDDB.XSLExtractTitle, undefined, topic.topicID, loadDDB.language, relatedLink.resolutionMode);
            $element.find("[data-attributes='no-link-title']").text($(fragment).text())

            resolve();
        }, function fail() {
            resolve();
        }, {});
    });
}

relatedLink.searchHrefId = function(topic) {
    let id = navigationWeb.mapSummaryHrefId[topic.file]
    if (id === undefined) {
        if (topic.parent !== undefined) {
            id = topic.parent.id
            if (id === undefined) {
                relatedLink.searchHrefId(topic.parent);
            }
        }
    }

    return id;
}

relatedLink.initShowRelatedLink = function ($newContent) {
    let $relatedLinksWrapper = $newContent.find("[data-role='related-links-wrapper']")

    for (let relatedLinksWrapperElement of $relatedLinksWrapper) {
        $(relatedLinksWrapperElement).on("click", function (event) {
            if (!event.target.closest(".related-links-wrapper-content")) {
                let isClosedRelatedLinksWrapper = $(this).hasClass("closed-related-links-wrapper")
                relatedLink.toggle(isClosedRelatedLinksWrapper, $(this))
            }
        });
    }
}

relatedLink.toggle = function (isExpanded, $element) {
    const dataTopicHref = $($element).attr("data-topichref")

    if (isExpanded) {
        $($element).removeClass("closed-related-links-wrapper")
        $($element).addClass("opened-related-links-wrapper")

        if ($.inArray(dataTopicHref, relatedLink.relatedLinksStates) < 0) {
            relatedLink.relatedLinksStates.push(dataTopicHref)
        }
    } else {
        $($element).removeClass("opened-related-links-wrapper")
        $($element).addClass("closed-related-links-wrapper")

        relatedLink.relatedLinksStates = relatedLink.relatedLinksStates.filter(function (e) {
            return e !== dataTopicHref
        })
    }
    historique.updateState()
}
